<template>
  <div class="ima-header">
    <div class="ima-header__container">
        <a class="ima-header__logo-link" href="http://www.ima-international.com" target="_blank">
        <svg class="ima-header__logo" width="50" height="50" viewBox="0 0 350 350" overflow="auto" xml:space="preserve">
  <circle stroke="#fff" stroke-width="10" fill="none" cx="175" cy="175" r="170"></circle>
	<path fill-rule="evenodd" fill="#FFFFFF" d="M106.2,121.8h31.4l29.7,75.9l30.6-75.9h30v3.4h-13.2v90.7h3.8h9.4h2l32.2-95.8h2.7
		l31.5,95.8h12.6v3.4H265v-3.4h14.2l-9.3-30.6h-25.4l-10,30.6h14.3v3.4h-21h-9.4h-33.8v-3.4h15.3v-88.4h-0.3l-37.4,93.5h-2
		l-36.4-93.5h-0.3v88.4h14.7v3.4h-32.1v-3.4h13.2v-90.7h-13.2V121.8z M69.8,215.9v-90.7H56.9v-3.4h41.2v3.4H85.3v90.7h12.8v3.4H56.9
		v-3.4H69.8z M268.7,181.1l-10.8-34.9h-0.3l-11.7,34.9H268.7z"></path>
</svg>
        </a>

      <div class="ima-header__brand">
        <div>
        <svg width="142.74" height="27.45" viewBox="0 0 142.74 27.45">
          <path d="M96.29,19.85V13.56c0-2.4,1.41-3.91,4-4.25a5.52,5.52,0,0,1,2.07.06V5.11c-3.69,0-5.44.93-6.23,3.54h-.06v-3H90.67V19.85h5.62"/>
          <path d="M124.44,15.29c1,4.05,5,5.28,10.07,5.28,4,0,8.23-1.47,8.23-5.38,0-5.92-12.15-3.67-12.15-6.12,0-1,1.85-1.21,2.76-1.21a6.6,6.6,0,0,1,2.42.52c.38.33.85.62.92,1.23h5.38c-1-3.06-4.4-4.73-8.48-4.73-4.93,0-8.81,1.56-8.81,5.24,0,5.6,12.11,3.44,12.11,6.06,0,1.11-1.92,1.38-3.13,1.32a5.08,5.08,0,0,1-2.65-.71,2.32,2.32,0,0,1-1.06-1.5h-5.61"/>
          <path d="M36.86,5.73v7.79a3.24,3.24,0,0,1-3.25,3.41,3.3,3.3,0,0,1-3.25-3.56V5.73H24.7v8.34c0,4.14,3.46,6.36,6.94,6.36A7.33,7.33,0,0,0,37,18.28H37v1.61h5.51V5.73H36.86"/><path d="M116.24,5.62v7.79A3.24,3.24,0,0,1,113,16.82a3.31,3.31,0,0,1-3.25-3.56V5.62l-5.65,0V14c0,4.15,3.46,6.37,6.94,6.37a7.33,7.33,0,0,0,5.32-2.15h.06v1.61h5.51V5.62h-5.67"/>
          <path d="M116.24,5.62v7.79A3.24,3.24,0,0,1,113,16.82a3.31,3.31,0,0,1-3.25-3.56V5.62l-5.65,0V14c0,4.15,3.46,6.37,6.94,6.37a7.33,7.33,0,0,0,5.32-2.15h.06v1.61h5.51V5.62h-5.67"/><path d="M0,27.45h141.9V25.91H0Z"/>
          <path d="M55.68,16.91a4.26,4.26,0,0,1-4.33-4.18,4.33,4.33,0,0,1,8.65,0,4.25,4.25,0,0,1-4.32,4.18m4-16.84v6.6C58.29,5.36,56.07,5,54.09,5c-6,.09-8.81,4.6-8.81,8,0,4.76,5.16,7.54,8.89,7.54,2.46,0,4.64-.73,5.66-2.23h.07V20h5.57V.07H59.73"/>
          <path d="M74.4,11a3.53,3.53,0,0,1,3.7-3,3.49,3.49,0,0,1,3.66,3H74.4M78.2,5c-5.84,0-10,2.76-10,8.06,0,5,4.7,7.58,10,7.58,4,0,7.72-1.51,9.25-4.77h-5.6c-.73,1.26-2.13,1.58-3.58,1.58A3.53,3.53,0,0,1,74.3,14H88C88.54,10,85.76,5,78.2,5"/>
          <path d="M10.85,16.24H6v-4.7h6.27c2.27,0,3.16.79,3.16,2.49,0,1.53-.93,2.21-4.55,2.21M6,3.85h5.82c2.49,0,3.13.74,3.13,1.87S14.28,8,11.79,8H6ZM17.26,9.42l-.15,0,0-.06.12,0c2.6-.47,4.26-2.22,4.07-4.75-.14-1.86-1-4.83-8.71-4.66H0V20.08l14.22,0c5.58.07,8-2.86,8-5.76,0-2.49-1.9-4.45-4.93-4.87"/>
          </svg>
        </div>
      </div>

      <div class="ima-header__settings">

        <ima-user-info class="ima-header__user-info" :user="user.data">
        </ima-user-info>

        <div class="ima-header__role-switch">
          <b-select icon="perm_identity" :value="user.data.role" :disabled="availableRoles.length === 1" @input="onRoleChange">
            <option v-for="role in availableRoles" :key="role.id" :value="role.id">{{role.name}}</option>
          </b-select>
        </div>

        <button type="button " class="button is-link ima-header__logout" @click="onLogoutClick() ">
          <span class="is-link ima-header__logout-label">Logout</span>
          <b-icon icon="exit_to_app " size="is-medium"> </b-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { logout, changeRole } from '@/store/modules/user'
import router from '@/router'
import routes from '@/mixins/routes'
import UserInfo from '@/components/UserInfo'
import { canNavigateToRoute } from '@/services/permissions'
import inform from '@/services/inform'

export default {
  name: 'ima-header',
  mixins: [routes],
  components: {
    'ima-user-info': UserInfo
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['user', 'roles']),
    availableRoles () {
      if (!this.user.data || !this.roles.data) {
        return []
      }
      return this.user.data.roles
        .map(id => {
          return this.roles.data.find(role => role.id === id)
        })
        .sort(({ id }) => id)
        .reverse()
    }
  },
  methods: {
    ...mapMutations([changeRole]),
    ...mapActions([logout]),
    onRoleChange (role) {
      this.changeRole(role)
      if (!canNavigateToRoute(this.$router.currentRoute.name)) {
        inform(
          `Die Userberechtigungen sind für diese Ansicht nicht ausreichend`,
          'is-warning'
        )
        router.push({ name: this.routes.DASHBOARD })
      }
    },
    onLogoutClick () {
      this.logout().then(() => {
        router.push({ name: this.routes.LOGIN })
      })
    }
  }
}
</script>


<style scoped lang="scss">
@import '../scss/settings';
.ima-header {
  background-color: #000;
  box-shadow: 0 0.1rem 0.2rem 0px rgba(0, 0, 0, 0.15);
  color: #fff;

  &__container {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0.7rem 0;
    max-width: calc(100vw - 0.7rem * 2);
  }

  &__logo-link {
    width: $nav-width;
    user-select: none;
    text-decoration: none;
  }

  &__logo {
    display: block;
    margin: 0 auto;

    // &:hover {
    //   circle {
    //     stroke: #006682;
    //   }
    // }
  }

  &__brand {
    justify-self: flex-start;
    flex-grow: 1;
    //padding-left: 1.5rem;
    border-left: 1px solid #fff;

    div {
      background-color: $primary;
      position: absolute;
      padding: 20px 22px 15px 22px;
      top: 2px;
    }

    svg {
      position: relative;

      path {
        fill: #fff;
        fill-rule: nonzero;
        stroke: none;
      }
    }
  }

  &__settings {
    display: flex;
    align-items: center;
  }

  &__user-info,
  &__role-switch {
    border-right: 1px solid darken($secondary, 10);
    padding-right: 1.2rem;
  }

  &__role-switch {
    display: flex;
    align-items: center;
    padding-left: 1.2rem;
  }

  &__logout {
    color: #fff !important;
    text-decoration: none;
    margin: 0 0.5rem;
    text-decoration: none !important;

    &:hover,
    &:focus {
      background: transparent !important;
      color: $highlight !important;
    }
  }

  &__logout-label {
    margin-right: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue